import { createSlice, Slice } from "@reduxjs/toolkit";

const resourcesSlice: Slice = createSlice({
  name: "resources",
  initialState: [],
  reducers: {
    getAll(state, action) {
      return action.payload;
    },
  },
});

export const { getAll } = resourcesSlice.actions;
export default resourcesSlice.reducer;
